import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";
import { Button } from "./Button";
import { HelpButton } from "./HelpButton";
import { ArrowLeftIcon, GlobeIcon } from "./Icons";

interface AppHeaderProps {
  readonly backLabel?: string;
  readonly onBack?: () => void;
}

/**
 * Minimal top bar shared by every screen: an optional back affordance on the
 * left, and a consistent language + help cluster on the right. No brand text —
 * screens that want a title (e.g. home) render their own in the body.
 */
export function AppHeader({ backLabel, onBack }: AppHeaderProps) {
  const t = useUiText();
  const uiLanguage = useAppStore((state) => state.uiLanguage);
  const setUiLanguage = useAppStore((state) => state.setUiLanguage);

  return (
    <header className="app-header">
      <div className="app-header__leading">
        {onBack === undefined ? null : (
          <Button
            aria-label={backLabel ?? t("common.back")}
            className="icon-label-button"
            icon={<ArrowLeftIcon />}
            onClick={onBack}
            variant="ghost"
          >
            {backLabel ?? t("common.back")}
          </Button>
        )}
      </div>

      <div className="app-header__actions">
        <Button
          aria-label={t("language.switch")}
          className="language-button"
          icon={<GlobeIcon />}
          onClick={() => setUiLanguage(uiLanguage === "zh" ? "en" : "zh")}
          variant="ghost"
        >
          {t("language.short")}
        </Button>
        <HelpButton />
      </div>
    </header>
  );
}
